'use client';
import { useUserStore } from '@unifyapps/carbon/auth/UserStoreProvider';
import { type ShowDrawer, useDrawer } from '@unifyapps/carbon/components/Drawer';
import { NavigationContainer } from '@unifyapps/carbon/components/NavigationContainer';
import { EnabledUnOpenedNotification } from '@unifyapps/carbon/components/Notifications/components/EnabledUnOpenedNotification';
import type { InterfaceEntity, NavigationResolution } from '@unifyapps/defs/types/interface';
import type { ReactNode } from 'react';
import SideOrBottomNavController from './SideOrBottomNavController';

export function SideOrBottomNav({
  interfaceRecord,
  resolution,
  children,
}: {
  interfaceRecord?: InterfaceEntity;
  resolution: NavigationResolution;
  children?: ReactNode;
}) {
  const { show: showDrawer, isOpen: isDrawerOpen, hide: hideDrawer } = useDrawer();
  const data = useUserStore().hooks.useCurrentUserDetails();
  const loggedInUserId = data?.user?.id;

  return (
    <EnabledUnOpenedNotification
      loggedInUserId={loggedInUserId}
      topics={data?.notificationMqttTopics}
    >
      {(unOpenedNotificationCount) => (
        <SideOrBottomNavController
          hideDrawer={hideDrawer}
          interfaceRecord={interfaceRecord}
          isDrawerOpen={Boolean(isDrawerOpen)}
          resolution={resolution}
          showDrawer={showDrawer as ShowDrawer}
          unopenedNotificationsCount={unOpenedNotificationCount}
        >
          {children ?? (
            /* @ts-expect-error app and navigation supplied by wrapper */
            <NavigationContainer />
          )}
        </SideOrBottomNavController>
      )}
    </EnabledUnOpenedNotification>
  );
}
